import { ArrowRight, ArrowUpRight } from 'lucide-react'

import Button from '/react4xp/components/prototype/Button'
import Card from '/react4xp/components/prototype/Card'

import type { RelatedArticlesProps } from './types'

export default function RelatedArticles({ overline, heading, viewAllLink, cards = [] }: RelatedArticlesProps) {
	if (!cards || cards.length === 0) return null

	const viewAllButton = viewAllLink && (
		<Button
			variant="link"
			href={viewAllLink.url}
			isExternal={viewAllLink.isExternal}
		>
			{viewAllLink.text}
			{viewAllLink.isExternal ? (
				<ArrowUpRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
			) : (
				<ArrowRight className="h-[1lh] w-5 shrink-0" aria-hidden="true" />
			)}
		</Button>
	)

	return (
		<section className="my-16">
			<div className="container">

				<div className="flex items-start justify-between gap-8">
					<div className="flex flex-col">
						{overline && <p className="body text-black-950">{overline}</p>}
						{heading && <h2 className="h2 text-black-950 max-w-175">{heading}</h2>}
					</div>

					{viewAllLink && (
						<span className="hidden lg:flex shrink-0">
							{viewAllButton}
						</span>
					)}
				</div>

				<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 mt-12">
					{cards.map((card, i) => (
						<Card
							key={i}
							image={card.image && { src: card.image.src, alt: card.image.alt ?? '' }}
							label={card.label}
							title={card.title}
							url={card.url}
							isExternal={card.isExternal}
							titleSize="h3"
							variant="article"
						/>
					))}
				</div>

				{viewAllLink && (
					<span className="flex lg:hidden mt-8">
						{viewAllButton}
					</span>
				)}

			</div>
		</section>
	)
}
